import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";

import TableRegisterButton from "../components/table/registerButton";
import Table from "../components/table/table";

import ROUTES from "../data/routes";
import { history } from "../routers/AppRouter";

import {
  getBranchManager,
  updateBranchManager,
  deleteBranchManager,
  getBranchManagersReportCsv,
} from "../app/store/actions/branch_manager";
import ModalComponent from "../components/modal";

class BranchManagerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 20,
      page: 1,
      search: "",
      orderBy: "ASC",
      field: "createdAt",
      showModal: false,
      branchManagerToDelete: null,
    };
  }

  componentDidMount() {
    this.searchBranchManagers();
  }

  searchBranchManagers = async () => {
    const {
      search = "",
      page,
      limit,
      orderBy = "ASC",
      field = "",
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems({
      limit,
      skip,
      search,
      order: orderBy,
      field,
    });
  };

  updateValues = async (search = "", page = 1) => {
    await this.setState({ search, page });
    await this.searchBranchManagers();
  };

  activeUser = async (id, status) => {
    try {
      await this.props.updateBranchManagerStatus({
        id,
        status,
      });
      await this.searchBranchManagers();
    } catch (error) {
      console.log(error);
    }
  };

  selectExportAccessCsv = async (value) => {
    const { clientId, iniDate, finDate, standardDays } = this.state;
    if (!value) {
      const result = await this.props.getCsvUsersAccessReport(
        clientId,
        standardDays,
        iniDate,
        finDate
      );
      if (!result) {
        this.failedModal();
      }
    }
    await this.setState({ showModal: value });
  };

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchBranchManagers();
  };

  deleteBranchManagerModal = async (id) => {
    await this.setState({ showModal: true, branchManagerToDelete: id });
  };

  deleteBranchManager = async () => {
    const { branchManagerToDelete } = this.state;
    await this.props.deleteBranchManager(branchManagerToDelete);
    await this.setState({ showModal: false, branchManagerToDelete: null });
    await this.searchBranchManagers();
  };

  selectExportAccessCsv = async () => { 
    this.props.getCsvBranchManagersReport();
  }

  render() {
    const { limit, page, showModal } = this.state;
    const { branchManagers = [] } = this.props;

    const tableHeader = [
      { key: "id", value: "id" },
      { key: "branchName", value: I18n.t("place") },
      { key: "storeBranchCode", value: I18n.t("storeBranchCode") },
      { key: "emailManager", value: `${I18n.t("emailManager")} Comercial` },
      { key: "status", value: I18n.t("status") },
      { key: "action", value: I18n.t("action") },
    ];

    const tableData = (branchManagers.rows || []).map((row, index) => ({
      key: index,
      id: row.id,
      branchName: row.branchName,
      storeBranchCode: row.storeBranchCode,
      emailManager: row.emailManager,
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${
              row.status === "active" ? "warning" : "dark"
            } promotion-btn-${row.status === "active" ? "warning" : "active"}`}
            onClick={() =>
              this.activeUser(
                row.id,
                row.status === "active" ? "inactive" : "active"
              )
            }
          >
            <Translate value={row.status === "active" ? "disable" : "active"} />
          </button>
        </div>
      ),
      action: (
        <div
          className="btn-group"
          role="group"
          aria-label="Button group with nested dropdown"
        >
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                onClick={() =>
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: "branchManager",
                    item: row,
                  })
                }
                className="dropdown-item dropdown-table"
              >
                <Translate value="edit" />
              </button>
              <button
                type="button"
                onClick={() => this.deleteBranchManagerModal(row.id)}
                className="dropdown-item dropdown-table"
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton
          route={{
            pathname: ROUTES.FORM,
            screenComming: "branchManager",
          }}
        />
        <button
          onClick={() => this.selectExportAccessCsv()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <Table
          title={I18n.t("branchManager")}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={branchManagers.count || 0}
          searchItems={this.updateValues}
          clientData={this.props.location.item}
          showItemsCount
          sortTable={this.sortTable}
        />

        <ModalComponent
          title={I18n.t("delete")}
          body={I18n.t("confirmDeleteBranchManager")}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t("confirm")}
          size={{ width: "300px" }}
          showButtons
          showCancel
          confirmModal={this.deleteBranchManager}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  searchItems: ({ limit, skip, clientId, search, order, field }) =>
    dispatch(
      getBranchManager({
        limit,
        skip,
        clientId,
        search,
        order,
        field,
      })
    ),
  updateBranchManagerStatus: (updatedFields) =>
    dispatch(updateBranchManager(updatedFields)),
  deleteBranchManager: (id) => dispatch(deleteBranchManager(id)),
  getCsvBranchManagersReport: () => dispatch(getBranchManagersReportCsv()),
});

const mapStateToProps = (state) => ({
  branchManagers: state.branchManager,
});

export default connect(mapStateToProps, mapDispatchToProps)(BranchManagerPage);
